
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    title: String,
    message: String,
    shouldOpen: Boolean,
  },
  data() {
    return {
      showModal: this.shouldOpen,
      showDone: false,
    };
  },
  watch: {
    shouldOpen() {
      this.showModal = this.shouldOpen;
    },
  },
})
export default class Alert extends Vue {
  title!: String;
  message!: String;
  shouldOpen!: Boolean;
  showModal!: Boolean;
  showDone!: Boolean;
  private keyboardEL: any;

  clickBackground(event: PointerEvent) {
    if (this.showDone && event.target === event.currentTarget) {
      this.showModal = false;
    }
  }

  afterFadeIn() {
    this.showDone = true;
    this.keyboardEL = document.addEventListener("keyup", (event) => {
      if (event.key === "Escape") {
        this.showModal = false;
      }
    });
  }
  beforeFadeOut() {
    this.showDone = false;
    document.removeEventListener("keyup", this.keyboardEL);
    this.keyboardEL = undefined;
  }
}
